import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ExperimentOutlined } from "@ant-design/icons";

import useIsMainAdmin from "../../hooks/useIsMainAdmin";
import { MainColor, SubColor } from "../../style/styleValue";

// 현재 랜딩 페이지에서 리뉴얼 시안으로 이동하는 버튼 (관리자에게만 노출)
const LandingDraftButton = () => {
  const navigate = useNavigate();
  const isAdmin = useIsMainAdmin();

  if (!isAdmin) return null;

  return (
    <FloatingButton type="button" onClick={() => navigate("/landing-renewal")}>
      <ExperimentOutlined /> 신규 디자인 시안 보기
    </FloatingButton>
  );
};

const FloatingButton = styled.button`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 900;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(135deg, ${MainColor}, ${SubColor});
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(23, 55, 95, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 30px rgba(23, 55, 95, 0.38);
  }

  @media (max-width: 576px) {
    right: 16px;
    bottom: 16px;
    padding: 10px 16px;
    font-size: 0.85rem;
  }
`;

export default LandingDraftButton;
